import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './scss/style.scss'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { queryClient } from './config';
import { QueryClientProvider } from "react-query";
import { LanguageProvider } from './views/languageContext/LanguageProvider';
import { Timerprovider } from './views/TimerContext/Timerprovider';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
   
  <React.StrictMode>
<LanguageProvider>
  <Timerprovider>

    <App />
  </Timerprovider>
</LanguageProvider>
  </React.StrictMode>
 
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
